<template lang="pug">
  div.tenant-form.mx-auto
    v-card.pa-6
      v-card-title
        v-icon(color="primary" size="32") group
        h3.primary--text.ml-2 Mandant wählen

      v-form.mt-3(ref="tenant-form" lazy-validation @submit.prevent="() => {}")
        p.mb-4 Bitte wählen sie den Mandanten aus, welchen Sie bearbeiten möchten

        v-select(
          v-model="tenantId"
          label="Mandanten"
          dense
          outlined
          :items="tenants"
          :rules="[ rules.required ]"
        )

        v-row.mt-3
          v-col(cols="12")
            v-btn(block color="primary" dark @click="onSelectTenant") Wählen

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  computed: mapGetters([
    'userData'
  ]),

  methods: mapActions([
    'setUserTenantId',
    'saveLoginLog'
  ])
})
export default class Tenant extends Vue {
  tenantId = ''

  get tenants () {
    if (!this.userData || !this.userData.tenants) {
      return []
    }

    return this.userData.tenants
  }

  onSelectTenant () {
    if (!this.isFormValid('tenant-form')) {
      return
    }

    this.setUserTenantId(this.tenantId)
      .then(() => {
        this.gotoRoute('home')
        this.saveLoginLog()
      })
  }
}
</script>

<style scoped>
.tenant-form {
  margin-top: 150px;
  max-width: 450px;
  width: 100%;
}
</style>
